import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import RichTextEditor from 'react-rte';
import { useParams } from "react-router";
import { OrganizationContext } from '../../../Services/OrganizationContext';
import authService from '../../../Services/authService';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from "../Breadcrumb/Breadcrumb"

const EditSignature = () => {
  
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id.toString();
  const [formData, setFormData] = useState({
    name: '',
    state_id: '',
    city_id: '',
    area_id: '',
    description: '',
    alias:'',
    landmark:'',
    fax:'',
    latitude:'',
    longitude:'',
    manager_phone:'',
    owner_phone:'',
    Is_Active: '', 
  });
  const { organization } = useContext(OrganizationContext);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [areas, setAreas] = useState([]);
  const [file, setFile] = useState(null);
  const [editorState, setEditorState] = useState(RichTextEditor.createEmptyValue());

  useEffect(() => {
     //loadStates();
     loadData();
  }, []);

  const loadData = () => {
      const token = authService.getCurrentadmin().token; // Retrieve the token for authorizationauthorization // Retrieve the token for authorization
    
      // Construct the URL with the organization_id as a query parameter
      const url = new URL(authService.getApiUrl() + 'signature/'+id);
      //url.searchParams.append('organization_id', organization); // Append the organization_id as a query parameter
    
      fetch(url, {
        method: 'GET', // Set method to GET
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${token}`, // Include Authorization header with Bearer token if required
        },
      })
        .then((res) => {
          if (res.status === 401) {
            // If status is 401, redirect to the login page
            authService.logout();
            window.location.href="/admin"; 
          } else {
            return res.json(); // Proceed with parsing JSON if the response is okay
          }
        })
        .then((result) => {
          const data = result.data;
          setFormData({
            ...data // Convert "A" to true and "I" to false
          });

        })
        .catch((err) => {
          console.log(err.message); // Handle any errors
        });
    
  };




  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.files[0]);
    // setFormData({
    //   ...formData,
    //   image: file,
    // });
  };




  const convertImageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      
      // Resolve the base64 string when the file is successfully read
      reader.onload = () => resolve(reader.result);
      
      // Reject in case of any errors
      reader.onerror = error => reject(error);
    });
  };

  const[errors,setErrors]=useState({});

  const handleSubmit = async (event) => {
    event.preventDefault();

    const token = authService.getCurrentadmin().token; // Retrieve the token for authorizationauthorization // Retrieve the token for authorization
    const base64String = file?await convertImageToBase64(file):"";
    fetch(authService.getApiUrl() + 'updatesignature/'+id, {
    method: 'PUT', // Change method to PUT
    body: JSON.stringify({ 
      image:base64String,
    }), // Include the data to be updated in the body
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
    },
    })
    .then((res) => res.json())
    .then((result) => {
        //setFormData(result.data); // Set the form data with the result
        navigate(`/admin/authorized-signature`);
        //console.log(result.data)
    })
    .catch((err) => {
        console.log(err.message); // Handle any errors
    });


  };






  return (
    <div className='main-container'>
      <div className='container-fluid'>
      <Breadcrumb />
        {/* <div className='main-banner'>
          <div className='flex-cont'>
            <div className='breadcrum-cont'>
              <span><a href='#'>Home</a></span>
              <span className='seperator'></span>
              <span className='active-category'><a href='#'>Edit Organization</a></span>
            </div>
            <div className='back-btn'>
              <Link to="/organizations">Back</Link>
            </div>
          </div>
        </div> */}
        <div className='category-table'>
          <div className='flex-cont add-cat'>
            <div className='heading'>
              <h3>Edit Signature</h3>
            </div>
          </div>
          <div className="card">
            <div className="card-body custom-edit-service">
              <form className="needs-validation clearfix" onSubmit={handleSubmit} >
                <div className="addtest-fields mb-3">
                  <div className="flex-cont">

                    <div className="full-cont">
                      <div className='upload-img-cont'>
                        <span>Upload Image *</span>
                        <input
                          type="file"
                          accept="image/jpeg, image/png, image/gif"
                          name="image"
                          onChange={handleImageChange}
                          className="form-control"
                          
                        />
                        <small className="text-secondary">
                          Recommended image size is <b>300 × 300 px</b>
                        </small>
                      </div>
                      {formData.image && (
                        <div id="uploadPreview">
                          <ul className="upload-wrap">
                            <li>
                              <div className="upload-images">
                                <img
                                  alt="Organization"
                                  src={authService.getApiDomainUrl() + formData.image}
                                  style={{ maxWidth: '100px', maxHeight: '100px' }}
                                />
                              </div>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>

 
                  </div>



                </div>
                <div className="submit-section">
                
                <button
                    className="btn btn-primary submit-btn"
                    type="submit"
                    name="form_submit"
                    
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSignature;
